import { type APIResponse, type MatterStatusCategory } from "@/lib/types";
import { authenticatedFastApiAxiosInstance } from "../../http";
import { baseFastApiMatterRoute } from "./matter";

export const retrieveMatterStatusCategoriesV2 = () => {
  return authenticatedFastApiAxiosInstance
    .get<
      APIResponse<MatterStatusCategory[]>
    >(`${baseFastApiMatterRoute}/status-categories`)
    .then((res) => res.data);
};
